// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2WZIv","actions":"GroupTable_actions__oy1Mq","deleteModalFooter":"GroupTable_deleteModalFooter__2Q6fY"};